
import { create } from 'zustand';
import { Order } from '@/types/order';

interface OrderConfirmationState {
  order: Order | null;
  isOpen: boolean;
  openSheet: (order: Order) => void;
  closeSheet: () => void;
}

export const useOrderConfirmationStore = create<OrderConfirmationState>((set) => ({
  order: null,
  isOpen: false,
  openSheet: (order) => set({ isOpen: true, order }),
  closeSheet: () => set({ isOpen: false, order: null }),
}));
